import React from "react";
import { Link } from "react-router-dom";

// [Trust] [SEO/GEO] Footer → Bricks footer template. Hours, ABN and social links omitted until verified.
const LOGO_SRC = "https://cdn.magicpatterns.com/uploads/wfGFQpbMXGFxGofAbTAYd5/Oceanside_logo_transparent_PNG.png";
const exploreLinks = [{
  label: "Home designs",
  to: "/home-designs"
}, {
  label: "Our work",
  to: "/projects"
}, {
  label: "Our building process",
  to: "/our-process"
}, {
  label: "Pricing & inclusions",
  to: "/#inclusions"
}, {
  label: "FAQs",
  to: "/#faqs"
}, {
  label: "About us",
  to: "/about"
}, {
  label: "Book a consultation",
  to: "/contact"
}];
const serviceLinks = [{
  label: "Home designs & single-storey builds",
  to: "/#home-designs-service"
}, {
  label: "Custom homes",
  to: "/#custom-homes"
}, {
  label: "Knock-down/rebuilds",
  to: "/#knock-down-rebuild"
}, {
  label: "Rear-block homes",
  to: "/#rear-block-homes"
}, {
  label: "Developments",
  to: "/#developments"
}];
export function Footer() {
  return <footer className="border-t border-line bg-paper-deep" data-id="element-33" data-mp="2kcl3va4mcnwp">
      <div className="mx-auto max-w-site px-5 py-14 md:px-10 md:py-20" data-id="element-34" data-mp="2kb0ctuhijn3l">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12" data-id="element-35" data-mp="2p5e9e07ww09u">
          <div className="lg:col-span-4" data-id="element-36" data-mp="2bd7uehghvzbz">
            <Link to="/" aria-label="Oceanside Living home" className="inline-block" data-id="element-37" data-mp="2be9e1abktu5b">
              <img src={LOGO_SRC} alt="Oceanside Living" width={2576} height={1394} className="h-16 w-auto" loading="lazy" data-id="element-38" data-mp="2gc15k38b7e8z" />
            </Link>
            <p className="mt-6 max-w-xs text-[16px] leading-relaxed text-slate" data-id="element-39" data-mp="382ffxph468fw">
              New and custom home builders in Perth. Homes built to the standard we’d want for ourselves.
            </p>
          </div>

          <nav aria-label="Explore" className="lg:col-span-2" data-id="element-40" data-mp="2z17ui7zp5238">
            <h2 className="text-sm font-semibold text-charcoal" data-id="element-41" data-mp="2z3u38aybpnn1">Explore</h2>
            <ul className="mt-4 space-y-3 text-[15px]" data-id="element-42" data-mp="1imfzrof2viqr">
              {exploreLinks.map(link => <li key={link.label} data-id="element-43" data-mp="1no5epf5f8gk4">
                  <Link to={link.to} className="text-slate hover:text-charcoal hover:underline hover:underline-offset-4" data-id="element-44" data-mp="13khlvzp4d6tq">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="What we build" className="lg:col-span-3" data-id="element-45" data-mp="uquv6nzrqtre">
            <h2 className="text-sm font-semibold text-charcoal" data-id="element-46" data-mp="pu4ebyg53u4x">What we build</h2>
            <ul className="mt-4 space-y-3 text-[15px]" data-id="element-47" data-mp="ktztxxc42f9f">
              {serviceLinks.map(link => <li key={link.label} data-id="element-48" data-mp="func5r03jydp">
                  <Link to={link.to} className="text-slate hover:text-charcoal hover:underline hover:underline-offset-4" data-id="element-49" data-mp="ftlnuku2lfe1">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-50" data-mp="267b2fu166436">
            <h2 className="text-sm font-semibold text-charcoal" data-id="element-51" data-mp="2669s5rrz9lmi">Contact</h2>
            <address className="mt-4 space-y-3 text-[15px] not-italic text-slate" data-id="element-52" data-mp="21886cz36387c">
              <p data-id="element-53" data-mp="28saili7ihc99">
                <a href="tel:+61862850876" className="text-charcoal underline underline-offset-4" data-id="element-54" data-mp="28sshkmlk64kv">08 6285 0876</a>
              </p>
              <p data-id="element-55" data-mp="2dp981ng8cv14">
                <a href="mailto:admin@oceansideliving.com.au" className="break-all text-charcoal underline underline-offset-4" data-id="element-56" data-mp="2dor2u1blb6h2">
                  admin@oceansideliving.com.au
                </a>
              </p>
              <p data-id="element-57" data-mp="1pt4vobj84cm1">9/30 Dellamarta Road<br data-id="element-58" data-mp="1ptob9lleioww" />Wangara WA 6065</p>
              <p data-id="element-59" data-mp="1pupq815jfvjw">Builder registration BC 103813</p>
            </address>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-line pt-6 text-sm text-slate md:flex-row md:justify-between" data-id="element-60" data-mp="1usrh3897gz5x">
          <p data-id="element-61" data-mp="1ztoxpgekhl5b">© {new Date().getFullYear()} Oceanside Living</p>
          <p data-id="element-62" data-mp="23uhagjmne86c">Perth, Western Australia</p>
        </div>
      </div>
    </footer>;
}